export const CHANGE_DATE = "CHANGE_DATE";
export const UPDATE_FILTER_CHART_MAP = "UPDATE_FILTER_CHART_MAP";